module.exports = {
    headers:{
        navbar:['首页','主营产品','公司介绍','联系我们'],
        products:['产品一','产品二','产品三','产品四']
    },
    bodys:{
        infotitle:['公司地址','联系方式','公交地铁'],
        information:{
            address:'武汉市东湖新技术开发区华师园北路18号光谷科技港',
            phone:'027-63494808',
            bus:'公交：789至武大园路武大园1路',
            subway:'地铁：2号线-秀湖'
        }
    },
    footers:{
        baceInfo:{
            companyName:'武汉芸希信息科技公司',
            address:'武汉市东湖新技术开发区华师园北路18号光谷科技港',
            phone:'电话:1234567890',
            fax:'传真:1234567890',
            copyright:'版权所有©武汉芸希信息科技公司',
            record:'备案号:粤ICP备xxxxxxxxxx号'
        }
    }
    
}